const UTM_KEYS = ['utm_source', 'utm_campaign', 'gclid'] as const;

export interface UtmParams {
  utm_source?: string;
  utm_campaign?: string;
  gclid?: string;
}

export function captureUtmParams(): void {
  const params = new URLSearchParams(window.location.search);
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, value);
    }
  }
}

export function getUtmParams(): UtmParams {
  const result: UtmParams = {};
  for (const key of UTM_KEYS) {
    const value = sessionStorage.getItem(key);
    if (value) {
      result[key] = value;
    }
  }
  return result;
}
